"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/utils/defaultErrorHandler.ts
async function defaultErrorHandler(error) {
  throw error;
}


exports.default = defaultErrorHandler;

module.exports = exports.default;
